import React, { useState } from 'react';

import { Route, Routes, useNavigate } from 'react-router-dom';

import ErrorPage from 'components/pages/errors/common/ErrorPage';
import AccountRegistrationConfirmationPage from 'components/pages/registration/AccountRegistrationConfirmationPage';
import AccountRegistrationEmailSendPage from 'components/pages/registration/AccountRegistrationEmailSendPage';
import AccountRegistrationPage from 'components/pages/registration/AccountRegistrationPage';
import EmailRegistration from 'components/pages/registration/EmailRegistration';
import { AccountRegistrationFormValues } from 'interfaces/registration';

const AccountRegistration: React.FC = () => {
  const [formValues, setFormValues] = useState<AccountRegistrationFormValues>({
    password: '',
    password_confirmation: '',
    last_name: '',
    first_name: '',
    last_name_kana: '',
    first_name_kana: '',
    email: '',
    code: '',
  });

  const navigate = useNavigate();

  const clearOnlyPasswordsFormValues = (
    formValues: AccountRegistrationFormValues,
  ) => {
    setFormValues({
      last_name: formValues.last_name,
      first_name: formValues.first_name,
      last_name_kana: formValues.last_name_kana,
      first_name_kana: formValues.first_name_kana,
      email: formValues.email,
      code: formValues.code,
      password: '',
      password_confirmation: '',
    });
  };

  const onSubmit = (formValues: AccountRegistrationFormValues) => {
    // フォーム送信時: フォーム情報を保存して確認画面に遷移
    setFormValues(formValues);
    navigate('/registration/confirm');
  };

  const onBack = () => {
    // 戻るボタンを押したら、全てのフォーム情報をクリアしてフォーム画面に戻る
    clearOnlyPasswordsFormValues(formValues);
    navigate('/registration');
  };

  const onClickAccountRegistration = () => {
    navigate('/registration/email_sent');
  };

  const onResend = () => {
    // メール送信完了画面で再送信ボタン押下時: メール送信完了画面を再表示
    navigate('/registration/email_sent');
  };

  const onBackFromEmailSent = () => {
    // EmailSentPageから戻る場合も、パスワードをリセットして入力画面に戻る
    clearOnlyPasswordsFormValues(formValues);
    navigate('/registration');
  };

  const [showEmailRegistration, setShowEmailRegistration] = useState(false);

  const handleShowEmailRegistration = () => {
    setShowEmailRegistration(true);
  };

  // 旧導線への切り替え時は完全にEmailRegistrationに移行
  if (showEmailRegistration) {
    return <EmailRegistration />;
  }

  // 新導線のルーティング
  return (
    <Routes>
      <Route
        path=""
        element={
          <AccountRegistrationPage
            onSubmit={onSubmit}
            onShowEmailRegistration={handleShowEmailRegistration}
            formValues={formValues}
          />
        }
      />
      <Route
        path="/confirm"
        element={
          <AccountRegistrationConfirmationPage
            onBack={onBack}
            onClickAccountRegistration={onClickAccountRegistration}
            formValues={formValues}
          />
        }
      />
      <Route
        path="/email_sent"
        element={
          <AccountRegistrationEmailSendPage
            email={formValues.email}
            isFetching={false}
            onResend={onResend}
            onGoBack={onBackFromEmailSent}
          />
        }
      />
      <Route path="*" element={<ErrorPage type="not_found" />} />
    </Routes>
  );
};

export default AccountRegistration;
